<template>
  <HeadlessCombobox v-model="model" as="main" nullable class="relative">
    <RedesignSearchDestinationInput
      ref="searchInputRef"
      :handle-clear="handleClearWithFocus"
    />

    <RedesignSearchDestinationSuggestions
      :suggestions="suggestions"
      :is-open="isOpen"
      :query="query"
    />
  </HeadlessCombobox>
</template>

<script setup lang="ts">
import type { ComboboxInput } from '@headlessui/vue'
import type { SuggestionOption } from '~/composables/useDestinationSearch'

const searchInputRef = shallowRef<{
  inputRef: InstanceType<typeof ComboboxInput>
}>()

const model = defineModel<SuggestionOption | undefined>()

const context = provideSearchDestination(model)

function handleClearWithFocus() {
  context.handleClear()

  nextTick(() => {
    const inputEl = searchInputRef.value?.inputRef?.$el
    if (inputEl) {
      inputEl.value = ''
      inputEl.focus()
    }
  })
}

provide(DESTINATION_SEARCH_KEY, {
  ...context,
  handleClearWithFocus,
})

const { query, suggestions, isOpen } = context
</script>
